import cx from "classnames";
import React from "react";

export interface MessageBubbleProps {
  children: React.ReactNode;
  variant: "user" | "assistant";
  className?: string;
}

/**
 * MessageBubble provides consistent bubble styling for chat messages.
 * Handles different visual styles for user vs assistant messages.
 */
export const MessageBubble = ({
  children,
  variant,
  className,
}: MessageBubbleProps) => {
  const bubbleClassName = cx(
    "message-bubble mb-4 max-w-[80%] rounded-xl p-4",
    variant === "user"
      ? "ml-auto border border-[#AF936E] bg-[#FFFFFF] text-primary"
      : "mr-auto border border-[#AF936E] bg-[#FFF1E0] text-primary",
    className
  );

  const contentClassName = "flex flex-col gap-2";

  // Static bubble for historical messages
  return (
    <div className={bubbleClassName}>
      <div className={contentClassName}>{children}</div>
    </div>
  );
};
